import React from "react"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import ReassignCustomerTabContent from "./ReassignCustomerTabContent"
import Tabs from '../Tabs/Tabs'
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer, CardElement } from '@stripe/react-stripe-js'
import logToTestHarness from "resolve-url-loader/lib/log-to-test-harness"
// import ErrorHelper from '../Errors/ErrorHelper';


class ReassignCustomer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // reservation_segments: this.props.reservation_segments ? this.props.reservation_segments : [],
      customer: null,
      active_tab: 'reassign-customer-general',
      // payment_method: null,
      card: null,
      loading: false,
      errors: null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      stripe: null,
      image_group: this.props.image_group,
    }
    this.onChangeNote= this.onChangeNote.bind(this);
    this.onChangeImageGroup = this.onChangeImageGroup.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeCustomer = this.onChangeCustomer.bind(this);
    this.changeCardInput = this.changeCardInput.bind(this);
    this.setCard = this.setCard.bind(this);
    this.processCard = this.processCard.bind(this);
  };

  async componentDidMount(){
    const stripe = await loadStripe(this.props.public_gateway_key);
    this.setState({stripe: stripe});
  };



  render() {
    if(this.state.stripe) {
      return(
        <Elements
          stripe={this.state.stripe}
          options={{
            locale: navigator.languages && navigator.languages.length
              ? navigator.languages[0]
              : navigator.language
          }}
        >
          <ElementsConsumer>
            {({ stripe, elements }) => (
              [
                <div className="reassign-customer" key="reassign-customer">
                  <div className="panel panel-form">
                    <Tabs tabs={this.tabs()} displayErrorMessage={false} />
                    <ReassignCustomerTabContent {...this.state}
                      onToggleCustomerCardForm={this.onToggleCustomerCardForm}
                      date_format={this.props.date_format}
                      time_format={this.props.time_format}
                      reassign_customer_data_table_path={this.props.reassign_customer_data_table_path}
                      reservation_segments={this.props.reservation_segments}
                      read_only={this.props.read_only}
                      onChangeNote={this.onChangeNote}
                      onChangeImageGroup={this.onChangeImageGroup}
                      onChangeFlagged={this.onChangeFlagged}
                      onChangeCustomer={this.onChangeCustomer}
                      changeCardInput ={this.changeCardInput}
                      addCard={this.addCard}
                      setCard ={this.setCard}
                      resetCardDetails={this.resetCardDetails}
                      errors={this.state.errors}
                    />
                  </div>

                  <LoadingSpinner show={this.state.loading} />
                  <ModalButtons loading={this.state.loading} buttons={this.buttons(elements)} />

                </div>

              ])}
          </ElementsConsumer>
        </Elements>
      )
    } else {
      return(
        null
      );
    };
  };

  buttons = (elements=null) => {
    if (this.state.renderSuccess) {
      return (
        [
          {
            name: I18n.t('ok'),
            html_attributes: ['data-dismiss="modal"'],
            onClick: () => {
              parent.refresh_data();
              parent.hide_modal();
            }
          },
        ]
      )
    } else {
      return (
        [
          {
            name: I18n.t('cancel'),
            html_attributes: ['data-dismiss="modal"']
          },
          {
            name: I18n.t('submit'),
            button_classes: ['primary'],
            onClick: () => {
              this.processCard(elements)
            },
          },
        ]
      );
    };
  };

  processCard = async (elements) => {
    const errors = {}

    if (this.state.card_id && Object.keys(errors).length == 0 || !this.state.customer || !this.state.card  || this.state.card && Object.keys(this.state.card).length == 1) {
      this.onSave(Object.assign({}, this.state));
    } else {
        if( ((this.state.card && !this.state.card_id && !this.state.displayNewCustomerCard) || !this.state.card)  ) {
          errors.card = [I18n.t('cant_be_blank')]
        };

        if(this.state.card && !this.state.card_id && this.state.displayNewCustomerCard){
          if (!this.state.card.name_on_card || /\d/.test(this.state.card.name_on_card)) {
            errors.name_on_card = [I18n.t('must_match')]
          };


          if (this.state.card && !this.state.card.token && this.state.card.name_on_card) {
            this.setState({
              lockSave: true,
            })
            const cardResponse = await this.generateCardToken(elements);

            if (cardResponse.error) {
              errors.card_validation = [cardResponse.error.message];
            } else if (cardResponse.paymentMethod) {
              const updatedState = Object.assign({}, this.state);

              updatedState.card.token = cardResponse.paymentMethod;

              // this.setState(updatedState);
              this.onSave(updatedState);
            } else {
              console.log('should not hit here potential async issue');
            };
          };
        };
      };

      if (Object.keys(errors).length == 0) {

      } else {
        this.setState({errors: errors});
      };

    };

  onToggleCustomerCardForm = () => {
    if (this.state.displayNewCustomerCard) {
      this.setState({
        displayNewCustomerCard: false,
        card: null,
        card_id: null,
      })
    } else {
      this.setState({
        displayNewCustomerCard: true,
        save_card: true,
        card_id: null,
        card: null,
      });
    };
  };



  onChangeActiveTab(active_tab) {

    this.setState({active_tab: active_tab})
  };

  onChangeImageGroup(image_group) {
    this.setState({image_group: image_group});
  };

  onChangeNote(noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      });
  };

  onChangeFlagged(event) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = event.target.checked
    this.setState({note_obj: note_obj});
  };

  onSave(updatedState) {
    var self = this;

    self.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: self.props.form_action,
      data: {
        reservation_segment_ids: this.props.reservation_segments.map((reservation_segment) => { return reservation_segment.id}),
        customer_id: updatedState.customer ? updatedState.customer.id : null,
        card: updatedState.card,
        card_id: updatedState.card_id,
        // card_token:
        note: updatedState.note_obj,
        image_group_images: updatedState.image_group && updatedState.image_group.images ? updatedState.image_group.images.map(function (image) { return image.id; }) : null,
      },
    }).done(function(data) {
      if (data.errors) {
        if (data.errors.card && self.state.card && self.state.card.token){
          var card = Object.assign({}, self.state.card)
          card.token = null;
        }
        self.setState({errors: data.errors, card: card ? card : null, loading:false})
      } else {
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t("customer_reassigned_successfully"))
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
        window.parent.$(window.parent).trigger("customer_reassigned_successfully")
      };
    });
  };


  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'reassign-customer-general',
          classes: this.state.active_tab === 'reassign-customer-general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          // tabErrorCount: RateBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'reassign-customer-notes',
          classes: this.state.active_tab === 'reassign-customer-notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          // tabErrorCount: RateBuilderErrors.billing_policy(this.state.errors).length
        },
      ]
    );
  };





  generateCardToken = async (elements) => {

    var stripe = this.state.stripe;
    var cardElement = elements.getElement(CardElement);

    if (!stripe || !cardElement) {
      console.log('We should never hit this! Either Stripe or Elements is not loaded!');
      return;
    };

    return await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: this.state.card.name_on_card,
      },
    });
  };


  onChangeCustomer(customer) {
    var defaultCard = customer && customer.cards && customer.cards.length  ? customer.cards.find(card => card.default) : null
    if(customer && customer.id){

      this.setState({
        customer: customer,
        card: defaultCard ? defaultCard : !customer.cards.length ? { save_card: false } : null,
        card_id: null,
        displayNewCustomerCard: !customer.cards.length ? true : false,
      });
    } else {
      this.setState({
        customer: null,
        card: {save_card: false}
      });
    };
  };

  setCard(id) {
    this.setState(
      {card_id: id}
    );
  };

  changeCardInput(card) {
    if (card) {
      if (card.name_on_card === '') {
        delete card.name_on_card;
      }
    
      this.setState({
        card: card
      });
    };
  };

};

export default ReassignCustomer
